<template>
  <div class="card-page">
    <Button type="primary" icon="plus-round" v-if="permissions === true" @click="edit(-1)">{{$t('Card.New_Card')}}</Button>
    <Button type="primary" icon="plus-round" v-if="permissions !== true" @click="edit(-1)" disabled>{{$t('Card.New_Card')}}</Button>
    <Table class="card-table" highlight-row stripe border :columns="columns" :data="datas"></Table>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Card',
  data () {
    return {
      columns: [
        { type: 'index', title: this.$t('Card.index'), width: 65 },
        { title: this.$t('Card.userName'), key: 'userName', sortable: true, sortType: 'asc' },
        { title: this.$t('Card.cardNo'), key: 'cardNo', sortable: true },
        { title: this.$t('Card.workTypeName'), key: 'workTypeName', sortable: true },
        {
          title: this.$t('Card.action'),
          key: 'action',
          width: 125,
          render: (h, params) => {
            if (this.permissions) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, this.$t('Card.edit')),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      if (confirm(this.$t('Card.delete_message'))) {
                        this.remove(params.index)
                      }
                    }
                  }
                }, this.$t('Card.delete'))
              ])
            } else {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, this.$t('Card.edit')),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: true
                  }
                }, this.$t('Card.delete'))
              ])
            }
          }
        }
      ],
      datas: [],
      permissions: false
    }
  },
  computed: {
  },
  methods: {
    edit (index) {
      let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({ name: 'CardEdit', params: { id } })
    },
    remove (index) {
      this.$api.card.delete(this.datas[index].id).then(() => {
        this.datas.splice(index, 1)
      })
    }
  },
  mounted () {
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'card' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.card.list().then(res => {
      next(vm => { vm.datas = res.cards })
    })
  }
}
</script>
<style>
.card-page {
  padding: 10px;
}

.card-table {
  margin-top: 20px;
}
</style>





// WEBPACK FOOTER //
// List.vue?b9ecba02